/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ButtonIcon as icon } from '../../components/Icons';
import styles from './inline-styles';
import { RichText, useBlockProps } from '@wordpress/block-editor';
/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Button' ),
	description: __( 'This block allows you to place an button.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Button' ),
	],
	parent: [ 'gutenify/buttons' ],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		anchor: true,
		align: false,
		alignWide: false,
		typography: {
			fontSize: true,
			__experimentalFontFamily: true,
		},
	},
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
	deprecated: [
		{
			attributes,

			save( props ) {
				const { className } = props;
				const {
					fontSize,
					linkTarget,
					rel,
					style,
					text,
					title,
					url,
					blockClientId,
				} = props.attributes;

				if ( ! text ) {
					return null;
				}

				const buttonClasses = classnames(
					'gutenify-button-link',
					'wp-block-button__link'
				);

				const wrapperClasses = classnames( className, {
					[ `has-custom-font-size` ]: fontSize || style?.typography?.fontSize,

				}, 'wp-block-button', `gutenify-section-${ blockClientId }` );

				return (
					<div { ...useBlockProps.save( { className: wrapperClasses } ) }>
						<RichText.Content
							tagName="a"
							className={ buttonClasses }
							href={ url }
							title={ title }
							value={ text }
							target={ linkTarget }
							rel={ rel }
						/>
					</div>
				);
			},
		},
	],
};

export { name, category, settings };
